export const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3001"

export function toIntOrNull(v: unknown): number | null {
  if (v === null || v === undefined) return null
  const s = String(v).trim()
  if (!s) return null
  const n = parseInt(s, 10)
  return Number.isNaN(n) ? null : n
}

export function toStrOrNull(v: unknown): string | null {
  if (v === null || v === undefined) return null
  const s = String(v).trim()
  return s || null
}

export function toUuidOrNull(v: unknown): string | null {
  const s = toStrOrNull(v)
  return s && s.length > 10 ? s : null
}
